<aside class="sidebar-document" #container [ngClass]="{'slide-sidebar-active': showDocumentDetails}" (click)="toggleSidebar()">
  <div (click)="$event.stopImmediatePropagation();" class="wrapper-sidebar" [ngClass]="{'wrapper-sidebar-active': showDocumentDetails}">
    <div class="sidebar-document-details">
      <div class="header-sidebar">
        <p>Informações do documento</p>
        <button type="button" aria-label="Fecha informações do documento" (click)="toggleSidebar()">
          <img src="/assets/images/close.svg" alt="Fechar">
        </button>
      </div>
      <div class="document-info">
        <div class="document-title">{{ document?.documentType }}</div>
        <envelope-status-badge [document]="document"></envelope-status-badge>
        <div class="label-title">Criado em</div>
        <div class="label-info">{{ document?.createdDate }}</div>
        <div class="label-title">Categoria</div>
        <div class="label-info">{{ document?.documentCategoryName || "&mdash;" }}</div>
        <div class="label-title">Identificador</div>
        <div class="label-info">{{ document?.uuid }}</div>
        <div class="div-actions">
          <a (click)="openDocumet();" type="button" class="btn-wrapper blue" [ngClass]="{ 'disabled': loadOpenDoc }" target="_blank">
            <div class="img-wrapper" *ngIf="!loadOpenDoc">
              <img class="item-main-infos icon" src="/assets/images/icon-eyes.svg" alt="Visualizar documento"/>Visualizar
            </div>
            <div *ngIf="loadOpenDoc" class="item-main-infos loading-wrapper">
              <div [ngClass]="{ 'loading': loadOpenDoc, '-white': loadOpenDoc }"></div>
            </div>
          </a>
          <a (click)="downloadDocumet();" type="button" class="btn-wrapper white last-button" [ngClass]="{ 'disabled': loadDownloadDoc }">
            <div class="img-wrapper" *ngIf="!loadDownloadDoc">
              <img class="item-main-infos icon" src="/assets/images/ico-download.svg" alt="Baixar documento"/>Baixar
            </div>
            <div *ngIf="loadDownloadDoc" class="item-main-infos loading-wrapper">
              <div [ngClass]="{ 'loading': loadDownloadDoc, '-blue': loadDownloadDoc }"></div>
            </div>
          </a>

        </div>
      </div>
      <div class="document-info">
        <p class="document-title">Emissor</p>
        <div class="label-title">Nome</div>
        <div class="label-info">{{ document?.emitterUserName || "&mdash;"  }}</div>
        <div class="label-title">Usuário</div>
        <div class="label-info">{{ document?.emitterUserEmail || "&mdash;" }}</div>
      </div>
      <div class="document-info" *ngFor="let subscriber of document?.subscribers; let i=index">
        <p class="document-title">Assinante {{ i+1 }}</p>
        <div class="label-title">Ordem</div>
        <div class="label-info">{{ subscriber?.subscriberOrder }}</div>
        <div class="label-title">Nome do assinante</div>
        <div class="label-info">{{ subscriber?.subscriberName }}</div>
        <div class="label-title">Telefone</div>
        <div class="label-info">{{ subscriber?.subscriberPhone | slice:0:2 }}  {{ subscriber?.subscriberPhone | slice:2:(subscriber?.subscriberPhone).length }}</div>
        <div class="label-title">E-mail</div>
        <div class="label-info">{{ subscriber?.subscriberEmail }}</div>
        <div class="label-title">CPF</div>
        <div class="link-text">
          <div *ngIf="!showCpf" class="label-info">***.***.***-**</div>
          <div *ngIf="showCpf" class="label-info">{{ subscriber?.subscriberCpf | slice:0:3 }}.{{ subscriber?.subscriberCpf | slice:3:6 }}.{{ subscriber?.subscriberCpf | slice:6:9 }}-{{ subscriber?.subscriberCpf | slice:9:11 }}</div>
          <a (click)="openCpf();">Mostrar CPF</a>
        </div>
      </div>
    </div>
  </div>
</aside>